var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divcreateorder"},[_c('createordercompose',{directives:[{name:"show",rawName:"v-show",value:(_vm.type == '进口1'),expression:"type == '进口1'"}],ref:"createordercompose"}),(_vm.type=='默认')?_c('haitaopackage',{ref:"haitaopackage",attrs:{"urlparam":_vm.pageparam,"curpkval":_vm.curpkval,"iscopy":_vm.iscopy}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }